import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./PhonePeAppForAllSection.css";
import AppStoreIcon from "../../../images/app-download/appstore.png";
import GoogleStoreIcon from "../../../images/app-download/googleplay.png";

const PhonePeAppForAllSection = () => {
    const data = useStaticQuery(graphql`
        query PhonePeAppForAllSectionQuery {
            mobileImage: file(
                relativePath: { eq: "app_download_for_all_mob-1x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(
                relativePath: { eq: "app_download_for_all_web-1x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    let sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    return (
        <WidgetContainer>
            <div className="app-download-overview">
                <div className="app-download-overview__content">
                    <h1>
                        India’s <br /> Payments App
                    </h1>
                    <p>
                        Transfer money, pay bills, make easy payments at stores
                        and invest smartly - all on the app you trust!
                    </p>
                    <div className="app-download-overview__content__download-btns">
                        <p>Download the App</p>
                        <div className="app-download-overview__content__download-btns__container">
                            <div>
                                <a
                                    href="https://phon.pe/appstoreIconWeb"
                                    target="_blank"
                                >
                                    <img
                                        src={AppStoreIcon}
                                        alt="app store icon"
                                    />
                                </a>
                            </div>
                            <div>
                                <a
                                    href="https://phon.pe/playstoreIconWeb"
                                    target="_blank"
                                >
                                    <img
                                        src={GoogleStoreIcon}
                                        alt="google store icon"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="app-download-overview__img-container">
                    <h1>
                        India’s Payments <br /> App
                    </h1>

                    <Img
                        fluid={sources}
                        alt="Download PhonePe"
                        imgStyle={{
                            objectFit: "contain",
                            height: "100%",
                        }}
                    />
                </div>
            </div>
        </WidgetContainer>
    );
};

export default PhonePeAppForAllSection;
